import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  Grid,
  useTheme,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
// import AddIcon from "@material-ui/icons/Add";
import HistoryIcon from "@material-ui/icons/History";
import ReceiptIcon from "@material-ui/icons/Receipt";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import EditIcon from "@material-ui/icons/Edit";
import FlightTakeoffIcon from "@material-ui/icons/FlightTakeoff";
import Header from "../../components/layout/Header/Header";
import Pane from "../../components/layout/Pane/Pane";
import PaneHeader from "../../components/layout/Pane/PaneHeader";
import { PaneBody } from "../../components/layout/Pane/PaneBody";
import Tabs from "../../components/layout/Pane/Tabs";
import Footer from "../../components/layout/Footer";
import OrderCard from "./Order";
import Photo from "./Photo";
import { PreviousOrders } from "../../components/Patrons/PreviousOrders";
import PatronList from "../../components/Patrons/List/PatronList";
import AddPatronButtons from "../../components/Patrons/AddPatronButtons";
import Preview from "./Preview";
import { UserContext } from "../../contexts/UserContext";
import { PaneContext } from "../../contexts/PaneContext";
import { OrderContext } from "../../contexts/OrderContext";
import Axios from "axios";
import { DatabaseContext } from "../../contexts/DatabaseContext";
import UpdatePasswordForSecurity from "../auth/UpdatePasswordForSecurity";

function Dashboard() {
  const { id, Site } = useContext(UserContext);
  const navigate = useNavigate();
  const { orders } = useContext(OrderContext);
  const { newPatronMode, activeTab } = useContext(PaneContext);
  const { palette } = useTheme();
  const { apiUrl } = useContext(DatabaseContext);
  //const [CheckWondeSchool, setCheckWondeSchool] = useState([]);

  const patronLabel =
    Site.siteType === 0 || Site.siteType === 5 ? "Student" : "Staff";

  const loginScreen = () => {
    navigate("/login", { replace: true });
  };

  useEffect(() => {
    // navigate("/login", { replace: true });
    if (id === undefined) {
      navigate("/login", { replace: true });
    }
  }, []);

  return id && Site ? (
    <Container>
      <Header />
      {/* <UpdatePasswordForSecurity /> */}
      <AddPatronButtons />
      <Panes container spacing={2} style={{ width: "100%", margin: 0 }}>
        <Grid item xs={12} md={4} lg={3} style={{ display: "flex" }}>
          <Pane colour={palette.secondary.main}>
            <PatronList />
          </Pane>
        </Grid>
        <Grid item xs={12} md={8} lg={6} style={{ display: "flex" }}>
          <Pane
            variant="new"
            //icon={<AddIcon/>}
            subHeader={`+ New ${patronLabel}`}
            colour={newPatronMode ? palette.success.main : palette.text.primary}
          >
            <Tabs
              colour={newPatronMode ? "success" : "text"}
              data={[
                {
                  index: 0,
                  title: newPatronMode ? (
                    <Typography style={Tstyles}>
                      {" "}
                      <EditIcon style={iconStyles} /> Create{" "}
                    </Typography>
                  ) : (
                    <Typography style={Tstyles}>
                      <FlightTakeoffIcon style={iconStyles} /> Order{" "}
                    </Typography>
                  ),
                  //title: newPatronMode ? 'Create' : 'Order',      // doesn't work this way
                  // Button: newPatronMode ? <EditIcon/> : <FlightTakeoffIcon/>,
                  component: <OrderCard />,
                  newPatronMode,
                },
                {
                  index: 1,
                  title: (
                    <Typography style={Tstyles}>
                      {" "}
                      <CameraAltIcon style={iconStyles} /> Photo{" "}
                    </Typography>
                  ),
                  //icon: {CameraAltIcon},
                  component: <Photo />,
                  newPatronMode,
                },
                {
                  index: 2,
                  title: (
                    <Typography style={Tstyles}>
                      {" "}
                      <HistoryIcon style={iconStyles} /> History{" "}
                    </Typography>
                  ),
                  //icon:{HistoryIcon},
                  component: <PreviousOrders />,
                  newPatronMode,
                },
              ]}
            />
          </Pane>
        </Grid>
        <Grid item xs={12} lg={3} style={{ display: "flex" }}>
          <Pane
            colour={
              (orders.length > 0 && activeTab === 0) ||
              (orders.length > 0 && activeTab === 2)
                ? palette.success.main
                : palette.text.primary
            }
          >
            <PaneHeader
              icon={
                orders.length > 0 && activeTab === 0 ? (
                  <ReceiptIcon />
                ) : (
                  <VisibilityIcon />
                )
              }
              title={
                (orders.length > 0 && activeTab === 0) ||
                (orders.length > 0 && activeTab === 2)
                  ? "Order Summary"
                  : "Preview"
              }
            />
            <PaneBody>
              <Preview />
            </PaneBody>
          </Pane>
        </Grid>
      </Panes>
      <Footer />
    </Container>
  ) : (
    //     ) : id && !Site ? (
    //  <div>User has no site attached.</div>

    loginScreen()
  );
}

const iconStyles = {
  fontSize: "18px",
};

const Tstyles = {
  fontWeight: "Bold",
  fontSize: "20px",
};

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Panes = styled(Grid)`
  flex: 1;
  display: flex;
  padding: 1rem 4rem;
`;

const StyledButton = styled(Button)`
  margin-bottom: 0.8rem;
`;

export default Dashboard;
